const smoothCards = [
  {
    id: '1',
    isLeft: true
  },
  {
    id: '2',
    isLeft: false
  },
  {
    id: '3',
    isLeft: true
  },
  {
    id: '4',
    isLeft: false
  },
  {
    id: '5',
    isLeft: true
  },
  {
    id: '6',
    isLeft: false
  },
  {
    id: '7',
    isLeft: true
  },
  {
    id: '8',
    isLeft: false
  },
  {
    id: '9',
    isLeft: true
  },
  {
    id: '10',
    isLeft: false
  }
]

export default smoothCards
